import React, { Component } from 'react';
import { Container, Row, Col, Badge } from 'react-bootstrap';
import { FiUser } from "react-icons/fi";
import UserIdentity from 'components/controls/userIdentity';
import AccountTypes from 'context/accountTypes';

export default class Page extends Component {
  render() {
    const user = this.props.user;
    return (
      <>
        <Container className="blob-header-row repo-name-row org-profile-row">
          <Row>
            <Col sm={1}>
              <FiUser className="w-100 h-100"/>
            </Col>
            <Col>
              <h5>
                {/* hideAccountId: the profile header is not the id's place — Settings → Profile
                    shows it in full, with a copy control. This must not be showIdentifier={false},
                    which would also strip a human's alias pill. */}
                <UserIdentity user={user} fallback={user.id} link={false} hideAccountId/>
                &nbsp;&nbsp;
                {this.props.app.api.isSelfUser(user) &&
                  <>
                    &nbsp;
                    <Badge variant="secondary" className="title-tag-badge">self</Badge>
                  </>
                }
                {AccountTypes.isRetired(user) &&
                  <>
                    &nbsp;
                    <Badge variant="secondary" className="title-tag-badge-muted">retired</Badge>
                  </>
                }
              </h5>
              {AccountTypes.isRetired(user) &&
                <div className="org-profile-item-row">
                  Credentials deleted, membership revoked, cannot be undone.
                </div>
              }
              {user.description &&
                <div className="org-profile-item-row">
                  {user.description}
                </div>
              }
              {user.url &&
                <div className="org-profile-item-row">
                  <a href={user.url}>{user.url}</a>
                </div>
              }
            </Col>
          </Row>
        </Container>
      </>
    )
  }
}
